import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img1 from "../../../images/podcast/1-min.png";
import Img2 from "../../../images/podcast/2-min.png";
import Img3 from "../../../images/podcast/3-min.png";
import Img4 from "../../../images/podcast/4-min.png";
import Img5 from "../../../images/podcast/6-min.png";
import Img6 from "../../../images/podcast/7-min.png";
import Img7 from "../../../images/podcast/8-min.png";
import Img8 from "../../../images/podcast/9-min.png";
import Img9 from "../../../images/podcast/10-min.png";
import Img10 from "../../../images/podcast/11-min.png";
import Img11 from "../../../images/podcast/12-min.png";
import Img12 from "../../../images/podcast/13-min.png";
import Img13 from "../../../images/podcast/14-min.png";
import Img14 from "../../../images/podcast/15-min.png";
import Img15 from "../../../images/podcast/16-min.png";
import Img16 from "../../../images/podcast/17-min.png";
import Img17 from "../../../images/podcast/18-min.png";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';




const responsive = {
    superLargeDesktop: {
        breakpoint: {max: 4000, min: 1600},
        items: 6
    },
    desktop: {
        breakpoint: {max: 1599, min: 1400},
        items: 6
    },
    tabletlandscape: {
        breakpoint: {max: 1399, min: 1200},
        items: 4
    },
    tablet: {
        breakpoint: {max: 1199, min: 667},
        items: 2
    },
    mobile: {
        breakpoint: {max: 666, min: 0},
        items: 1
    }
};


function Mention({data}) {
    return (
        <div className="podcast_story p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="m-auto text-center">
                        <h5 className="episode_name">
                            Mentioned
                        </h5>
                        <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={3000}
                                  arrows={false} className="carousel_featured">

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img1}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img2}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img3}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img4}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img5}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img6}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img7}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img8}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img9}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img10}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img11}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                                </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img12}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />

                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img13}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />

                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img14}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />

                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img15}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Img16}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                          <div className="featured_img">
                                <LazyLoadImage
                                   src={Img17}
                              effect="blur" alt="Image" className="img-fluid"
                                 />
                    </div>
                    </div>

                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Mention;